<template>
  <div class="flex flex-wrap reports">
    <div class="w-full search-courses-loading vs-con-loading__container">
      <vs-table-m
        @change-page="handleChangePageRatingReports"
        :sst="true"
        :total="getRatingReportList.total"
        :maxItems="pageSizeRatingReports"
        :data="getRatingReportList.items"
        pagination
        class="mt-5"
      >
        <template slot="header">
          <h4 class="w-full m-2 my-4 clear-both">Ratings Reports</h4>
          <div class="reports__filters flex w-full mb-5">
            <div class="w-1/3 mr-5 ml-auto">
              <label>From:</label>
              <datepicker v-model="ratingReportsFrom" @input="changeRatingReportsFilter"></datepicker>
            </div>
            <div class="w-1/3 mr-5 ml-auto">
              <label>To:</label>
              <datepicker v-model="ratingReportsTo" @input="changeRatingReportsFilter"></datepicker>
            </div>
            <vs-button @click="generateReport" class="self-end mt-5 ml-auto" icon-pack="feather">Generate report</vs-button>
          </div>
        </template>
        <template slot="thead">
          <vs-th sort-key="report_id">Report ID</vs-th>
          <vs-th sort-key="report_created">Created</vs-th>
          <vs-th sort-key="report_created_by">Created by</vs-th>
          <vs-th sort-key="report_status">Status</vs-th>
          <vs-th sort-key="report_download">Download</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="report" :key="indextr" v-for="(report, indextr) in data" class="report">

            <vs-td :data="report.id">{{ report.id }}</vs-td>
            <vs-td :data="report.created">{{ formatDate(report.created) }}</vs-td>
            <vs-td :data="report.created_by"><a :href="`${supportURL}/users/${report.created_by.uaa_id}`" target="_blank">{{ formatName(report.created_by) }}</a></vs-td>
            <vs-td :data="report.status">{{ formatStatus(report.status) }}</vs-td>
            <vs-td :data="report.download">
              <vs-button :disabled="['error', 'in_progress', 'error'].includes(report.status)" type="border" @click="downloadReport(report.id)" class="self-end" icon-pack="feather">Download</vs-button>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table-m>
      
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { mapActions, mapGetters } from "vuex"
import dayjs from 'dayjs'
import VsTableM from '@/components/VsTableM'

export default {
  name: 'Reports',
  components: {
    VsTableM,
    Datepicker,
  },
  data: () => {
    return {
      supportURL: process.env.VUE_APP_SUPPORT_URL,
      pageSizeRatingReports: 5,
      currentRatingReportsPage: 1,
      ratingReports: {
        total: 0,
        items: []
      },
      ratingReportsFrom: dayjs().subtract(3, 'month').toDate(),
      ratingReportsTo: new Date(),
      instructorsDateFrom: dayjs().subtract(3, 'month').toDate(),
      instructorsDateTo: new Date(),
    }
  },
  computed: {
    ...mapGetters('reporting', ['getRatingReportList']),
  },
  methods: {
    ...mapActions('reporting', ['getRatingReportsAction', 'createRatingReportAction', 'downloadReportAction']),
    async handleChangePageRatingReports(page) {
      this.currentRatingReportsPage = page;
      this.getRatingReportsAction({
        page: this.currentRatingReportsPage.toString(),
        page_size: this.pageSizeRatingReports.toString()
      });
    },
    async handleChangePageInstructorsRatings(page) {
      this.currentInstructorsRatingsPage = page;
      this.lastInstructorsRatings({
        page: this.currentInstructorsRatingsPage.toString()
      });
    },
    async getRatingReports(payload) {
      payload = {
        ...payload,
        page_size: this.pageSizeRatingReports.toString(),
        ordering: "-created",
        from: dayjs(this.ratingReportsFrom).format('YYYY-MM-DD'),
        to: dayjs(this.ratingReportsTo).add(1, 'day').format('YYYY-MM-DD'), // to 00:00:00 of next day.
      }
      this.$vs.loading({
        container: '.search-courses-loading',
        scale: 0.6
      })
      await this.search(payload)
      this.$vs.loading.close('.search-courses-loading > .con-vs-loading')
    },
    async changeRatingReportsFilter() {
      await this.getRatingReports({
        page: this.currentRatingReportsPage.toString()
      })
    },
    async search(payload = {}) {
      try {
        const response = await this.getRatingReportsAction(payload);
        return response
      } catch (error) {
        this.showError(error)
      }
    },
    formatDate(date) {
      return dayjs(date).format('MM/DD/YYYY HH:mm')
    },
    formatName(user) {
      // if user has first and last name, return it, otherwise return uaa_id
      return user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : user.uaa_id
    },
    formatStatus(status) {
      switch (status) {
        case 'initial':
          return 'Initial'
        case 'finished':
          return 'Finished'
        case 'in_progress':
          return 'In progress'
        case 'error':
          return 'Error'
        default:
          return 'Unknown'
      }
    },
    async generateReport() {
      try {
        this.$vs.loading({
          container: '.search-courses-loading',
          scale: 0.6
        })
        await this.createRatingReportAction({
          type: 'rating',
          from: dayjs(this.ratingReportsFrom).format('YYYY-MM-DD'),
          to: dayjs(this.ratingReportsTo).add(1, 'day').format('YYYY-MM-DD'), // to 00:00:00 of next day.
        })
        await this.getRatingReports()
        this.$vs.loading.close('.search-courses-loading > .con-vs-loading')
        this.$vs.notify({
          title: 'Report generated',
          text: 'The report has been generated and is being processed. You will see it on the list as finished.',
          color: 'success',
          position: 'top-right'
        })
      } catch (error) {
        this.$vs.loading.close('.search-courses-loading > .con-vs-loading')
        this.showError(error)
      }
      
    },
    async downloadReport(reportId) {
      try {
        this.$vs.loading({
          container: '.search-courses-loading',
          scale: 0.6
        })
        const response = await this.downloadReportAction({reportId})
        let link = document.createElement('a')
        link.href = response.data.download_url
        link.click()
        this.$vs.loading.close('.search-courses-loading > .con-vs-loading')
      } catch (error) {
        this.$vs.loading.close('.search-courses-loading > .con-vs-loading')
        this.showError(error)
      }
    },
  },

  async mounted() {
    try {
      this.$vs.loading()

      this.$nextTick()
        .then(() => {
          this.$vs.loading.close()
        })
      
      this.getRatingReports()

      
      // Load the static filtered searches
    } catch (error) {
      this.$vs.loading.close();
      this.showError(error)
    }
  },
};
</script>
